export const getQuoteData = (state) => state.quote

export const getAffiliateData = (state) => state.affiliate
